import { useTranslation } from 'react-i18next'
import { getClassNameForField, platformFields as fields } from '../../constants'
import { EditableFormPage } from '../components/EditableFormPage'
import { useTranslationService } from '../../util/TranslationContext'

const PlatformInformation = () => {
    const { translateFields } = useTranslationService()
    const platformFields = translateFields(fields, 'platform')
    const { t } = useTranslation()

    return (
        <EditableFormPage
            title={t('navigation_admin.platform_information')}
            fetchUrl={`admin/platform-information`}
            fields={platformFields}
            classNameForField={getClassNameForField}
            errorMessage='Failed to fetch platform data.'
        />
    )
}

export default PlatformInformation
